import { render, staticRenderFns } from "./OrderTabs.vue?vue&type=template&id=fb6baba0&scoped=true&"
import script from "./OrderTabs.vue?vue&type=script&lang=js&"
export * from "./OrderTabs.vue?vue&type=script&lang=js&"
import style0 from "../../styles/order-tabs.css?vue&type=style&index=0&id=fb6baba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6baba0",
  null
  
)

export default component.exports